import { ChangeDetectorRef, Component, Input } from '@angular/core';
import {
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { DjangoService } from '@core/services/django.service';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';
import { ActiveCampaignLeadMagnet } from '@generated/graphql';
import { SaveButtonComponent } from '@shared/save-button/save-button.component';

@Component({
    selector: 'app-lead-magnet-form',
    imports: [ReactiveFormsModule, SaveButtonComponent],
    templateUrl: './lead-magnet-form.component.html',
    styles: ``,
})
export class LeadMagnetFormComponent {
    @Input() leadMagnet: ActiveCampaignLeadMagnet;
    leadMagnetForm: UntypedFormGroup;

    showLoader = false;
    success = false;
    error = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private cd: ChangeDetectorRef,
        private djangoService: DjangoService,
        private eventTrackerService: EventTrackerService
    ) {}

    ngOnInit(): void {
        this.leadMagnetForm = this.formBuilder.group({
            firstName: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    onSubmit() {
        if (this.leadMagnetForm.valid) {
            this.showLoader = true;
            const values = this.leadMagnetForm.value;
            const data = {
                email: values.email,
                first_name: values.firstName,
                lead_magnet: this.leadMagnet.sys.id,
            };

            this.djangoService.leadMagnet(data).subscribe({
                next: () => {
                    this.showLoader = false;
                    this.success = true;
                    this.cd.detectChanges();

                    this.eventTrackerService.trackEvent(
                        ANALYTICS_EVENTS.LEAD_MAGNET_COMPLETED,
                        {
                            leadMagnet: this.leadMagnet.title,
                            tag: this.leadMagnet.activeCampaignTag,
                        },
                        data.email
                    );
                },
                error: error => {
                    this.success = false;
                    this.showLoader = false;
                    this.error = true;
                    this.cd.detectChanges();
                },
            });
        }
    }
}
